import React, { useEffect, useState } from "react";
import PageHero from "../../components/common/PageHero";
import DataTableCard from "../../components/common/DataTableCard";
import { Button, Input } from "reactstrap";
import swal from "sweetalert";

import { _Post } from "../../ApiEndPoint/ApiCalling";
import { Cashbook_Report } from "../../ApiEndPoint/Api";

export default function Cashbook() {
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // 🔥 API CALL
  const fetchCashbook = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("userData"));
      const res = await _Post(Cashbook_Report, user?.database, user?.database);

      const company = JSON.parse(localStorage.getItem("Companydetail"));
      const openingBalance = Number(company?.openingBalance) || 0;
      const openingType = company?.openingType?.toLowerCase();

      let data = [];

      // 🔥 SALES
      const sales = res?.CashBook?.salesData?.map((i) => ({
        date: i?.date?.split("T")[0],
        entryType: "sales",
        paymentMode: "Cash",
        particular: i?.party || "CASH",
        amount: Number(i?.amount),
      })) || [];

      // 🔥 PURCHASE
      const purchase = res?.CashBook?.purchaseData?.map((i) => ({
        date: i?.date?.split("T")[0],
        entryType: "purchase",
        paymentMode: "Cash",
        particular: i?.party || "CASH",
        amount: Number(i?.amount),
      })) || [];

      // 🔥 RECEIPT / PAYMENT
      const receipts = res?.CashBook?.receipts?.map((i) => ({
        date: i?.date?.split("T")[0],
        entryType: i?.type === "payment" ? "payment" : "receipt",
        paymentMode: i?.paymentMode || "Cash",
        particular: i?.partyId?.CompanyName || "N/A",
        amount: Number(i?.amount),
      })) || [];

      data = [...sales, ...purchase, ...receipts];

      // 🔥 OPENING
      const opening = {
        date: "",
        particular: "Opening Balance",
        amount: openingBalance,
        entryType: "opening",
        cashRunning:
          openingType === "credit" ? openingBalance : -openingBalance,
      };

      data.sort((a, b) => new Date(a.date) - new Date(b.date));

      let running = opening.cashRunning;

      const finalData = [opening];

      data.forEach((item) => {
        let debit =
          (item.entryType === "sales" && item.particular === "CASH") ||
          (item.entryType === "receipt" && item.paymentMode === "Cash") ||
          (item.entryType === "payment" && item.paymentMode === "Bank");

        let credit =
          (item.entryType === "purchase" && item.particular === "CASH") ||
          (item.entryType === "receipt" && item.paymentMode === "Bank") ||
          (item.entryType === "payment" && item.paymentMode === "Cash");

        if (debit) running += item.amount;
        else if (credit) running -= item.amount;

        finalData.push({
          ...item,
          cashRunning: running,
        });
      });

      setRows(finalData);
      setAllRows(finalData);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      swal("Error loading cashbook");
    }
  };

  useEffect(() => {
    fetchCashbook();
  }, []);

  // 🔥 FILTER
  useEffect(() => {
    let filtered = [...allRows];

    if (search) {
      filtered = filtered.filter((r) =>
        r.particular?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (startDate) {
      filtered = filtered.filter((r) => r.date >= startDate);
    }

    if (endDate) {
      filtered = filtered.filter((r) => r.date <= endDate);
    }

    setRows(filtered);
  }, [search, startDate, endDate]);

  // 🔥 EXPORT CSV
  const downloadCSV = () => {
    const header = ["Date", "Particular", "Amount", "Balance"];

    const csvRows = rows.map((r) => [
      r.date,
      r.particular,
      r.amount,
      r.cashRunning,
    ]);

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [header, ...csvRows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "cashbook.csv";
    link.click();
  };
const downloadPDF = () => {
  const doc = new jsPDF();

  const tableData = rows.map((r) => [
    r.date,
    r.particular,
    r.amount,
    r.cashRunning,
  ]);

  doc.autoTable({
    head: [["Date", "Particular", "Amount", "Balance"]],
    body: tableData,
  });

  doc.save("cashbook.pdf");
};
  return (
    <div className="erp-page-grid">
 

  {/* 🔥 HEADER ROW */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
    }}
  >
    {/* LEFT SIDE TITLE */}
    <h5 style={{ margin: 0 }}>Cash Transactions</h5>

    {/* RIGHT SIDE FILTERS */}
    <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
      
      <Input
        type="text"
        placeholder="Search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ height: "32px", fontSize: "12px", width: "150px" }}
      />

      <Input
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        style={{ height: "32px", fontSize: "12px" }}
      />

      <Input
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        style={{ height: "32px", fontSize: "12px" }}
      />

      {/* <Button
        color="danger"
        size="sm"
        onClick={downloadPDF} // 👈 add PDF function
      >
        PDF
      </Button> */}

      <Button
        color="success"
        size="sm"
        onClick={downloadCSV}
      >
        XLS
      </Button>
    </div>
  </div>

  {/* 🔥 TABLE */}
  <DataTableCard
    loading={loading}
    columns={[
      { key: "date", label: "Date" },
      { key: "particular", label: "Particular" },
      { key: "amount", label: "Amount" },
      { key: "cashRunning", label: "Balance" },
    ]}
    rows={rows.map((r) => ({
      date: r.date || "-",
      particular: r.particular,
      amount: `₹${r.amount || 0}`,
      cashRunning: `₹${Math.abs(r.cashRunning || 0)}`,
    }))}
  />
</div>
  );
}